import React from "react";
import { type ApiApplication } from "../../api.ts";
import { Button } from "../../components/button.tsx";
import { ConfigTable } from "../../components/config-table.tsx";
import { MaskedSecret } from "../../components/masked-secret.tsx";

interface OidcConfigTableProps {
  application: ApiApplication;
  onRotateSecret: () => void;
}

export function OidcConfigTable({
  application,
  onRotateSecret,
}: OidcConfigTableProps) {
  function handleRotate() {
    if (!confirm("Rotate the client secret? Existing integrations will break.")) {
      return;
    }
    onRotateSecret();
  }

  const { issuerUrl } = application;
  return (
    <ConfigTable
      rows={[
        ["Client ID", application.clientId],
        [
          "Client secret",
          <div className="flex items-center justify-between gap-2">
            <MaskedSecret prefix={application.clientSecretPrefix} />
            <Button
              variant="secondary"
              size="sm"
              onClick={handleRotate}
              className="shrink-0"
            >
              Rotate
            </Button>
          </div>,
        ],
        ["Issuer", issuerUrl],
        ["Discovery", `${issuerUrl}/.well-known/openid-configuration`],
        ["Authorization URL", `${issuerUrl}/authorize`],
        ["Token URL", `${issuerUrl}/token`],
        ["JWKS URL / Certificate URL", `${issuerUrl}/.well-known/jwks.json`],
        ["Userinfo URL", `${issuerUrl}/userinfo`],
      ]}
    />
  );
}
